import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from "react";
import { Filler, ItemContainer, MenuContainer } from "./styles";
import { MenuModal } from "./MenuModal";
import { AnimatePresence } from "framer-motion";
export var Menu = forwardRef(function Menu(_a, ref) {
    var _b = _a.menuItems, menuItems = _b === void 0 ? [] : _b, props = __rest(_a, ["menuItems"]);
    var _c = useState(null), modalItem = _c[0], setModalItem = _c[1];
    var location = window.location.pathname.split("/")[1];
    var toggleModalItem = function (item) {
        if ((modalItem === null || modalItem === void 0 ? void 0 : modalItem.id) === item.id) {
            setModalItem(null);
        }
        else {
            setModalItem(item);
        }
    };
    var handleClick = function (item, hasSubitems) {
        if (item.external) {
            window.open(item.external, "_blank");
            return;
        }
        if (hasSubitems || item.id.includes("search")) {
            toggleModalItem(item);
        }
    };
    return (_jsxs(MenuContainer, __assign({ ref: ref }, props, { children: [menuItems.map(function (item) {
                var _a;
                if (item.condition === false)
                    return;
                if (item.filler) {
                    return _jsx(Filler, { height: item.height || 20 }, item.id);
                }
                var hasSubitems = item.subitems && item.subitems.length > 0;
                var pathToGo = item.external || hasSubitems || !item.path ? "#" : item.path;
                return (_jsxs(ItemContainer, { id: "menu-item-".concat(item.id), to: pathToGo, "aria-selected": location === ((_a = item.path) === null || _a === void 0 ? void 0 : _a.split("/")[1]), onClick: function (e) {
                        e.stopPropagation();
                        handleClick(item, hasSubitems);
                    }, children: [item.icon, _jsx("span", { children: item.text })] }, item.id));
            }), _jsx(AnimatePresence, { children: modalItem && (_jsx(MenuModal, { item: modalItem, setModalItem: setModalItem, menuItems: menuItems })) })] })));
});
//# sourceMappingURL=index.js.map